import * as _m from '@/models';
import { DeltaJsonElement } from '@/components/common/DeltaJsonElement';
import { useEffect, useRef, useState } from 'react';

type Props = {
  channel_post: _m.ChannelPost;
};

export const Description = ({ channel_post }: Props) => {
  const [descriptionOpener, setDescriptionOpener] = useState<boolean>(false);
  const messageRef = useRef<HTMLDivElement>(null);
  const [openerId, setOpenerId] = useState(crypto.randomUUID());

  useEffect(() => {
    if (messageRef && messageRef.current) {
      if (messageRef.current.offsetHeight < messageRef.current.scrollHeight) {
        setDescriptionOpener(true);
      }
    }
  }, [messageRef]);

  return (
    <div className={`description ${descriptionOpener && 'active'}`}>
      <input type="checkbox" className="opener-checkbox" id={openerId} />
      <p ref={messageRef}>
        <DeltaJsonElement deltaJson={channel_post.message_json} keyPrefix={`channel_post_${channel_post.id}`} />
      </p>
      <label htmlFor={openerId} className="description-trigger"></label>
    </div>
  );
};
